import React from "react";
import { styled } from "@mui/material/styles";
import { Select as MuiSelect } from "@mui/material";

const Select = styled((props: any) => <MuiSelect {...props} />)(({}) => ({
    backgroundColor: '#FFF'
}));

export default Select;
